// Generated by ReScript, PLEASE EDIT WITH CARE
/* @generated */
'use strict';

let RescriptRelay = require("rescript-relay/src/RescriptRelay.bs.js");
let RescriptRelay_Internal = require("rescript-relay/src/RescriptRelay_Internal.bs.js");

let Types = {};

function unwrap_response_updateAgentProfilePersonalInfo(__x) {
  return RescriptRelay_Internal.unwrapUnion(__x, ["Agent"]);
}

let variablesConverter = {"updateAgentProfilePersonalInfoInput":{"website":{"b":""},"email":{"b":""}},"__root":{"input":{"r":"updateAgentProfilePersonalInfoInput"}}};

function convertVariables(v) {
  return RescriptRelay.convertObj(v, variablesConverter, undefined, undefined);
}

let wrapResponseConverter = {"__root":{"updateAgentProfilePersonalInfo_Agent":{"f":""},"updateAgentProfilePersonalInfo":{"u":"response_updateAgentProfilePersonalInfo"}}};

let wrapResponseConverterMap = {
  response_updateAgentProfilePersonalInfo: RescriptRelay_Internal.wrapUnion
};

function convertWrapResponse(v) {
  return RescriptRelay.convertObj(v, wrapResponseConverter, wrapResponseConverterMap, null);
}

let responseConverter = {"__root":{"updateAgentProfilePersonalInfo_Agent":{"f":""},"updateAgentProfilePersonalInfo":{"u":"response_updateAgentProfilePersonalInfo"}}};

let responseConverterMap = {
  response_updateAgentProfilePersonalInfo: unwrap_response_updateAgentProfilePersonalInfo
};

function convertResponse(v) {
  return RescriptRelay.convertObj(v, responseConverter, responseConverterMap, undefined);
}

let Internal = {
  variablesConverter: variablesConverter,
  variablesConverterMap: undefined,
  convertVariables: convertVariables,
  wrapResponseConverter: wrapResponseConverter,
  wrapResponseConverterMap: wrapResponseConverterMap,
  convertWrapResponse: convertWrapResponse,
  responseConverter: responseConverter,
  responseConverterMap: responseConverterMap,
  convertResponse: convertResponse,
  convertWrapRawResponse: convertWrapResponse,
  convertRawResponse: convertResponse
};

let Utils = {};

let node = ((function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "displayName",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "UnifiedYourProfilePersonalInformationForm_UpdateAgentProfilePersonalInfoMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "updateAgentProfilePersonalInfo",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "UnifiedYourProfilePersonalInformationForm_agent"
              },
              (v3/*: any*/)
            ],
            "type": "Agent",
            "abstractKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "UnifiedYourProfilePersonalInformationForm_UpdateAgentProfilePersonalInfoMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "updateAgentProfilePersonalInfo",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "firstName",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "lastName",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "brokerage",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "phone",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "emailAddress",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "website",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "userEnteredDisplayName",
                "storageKey": null
              },
              (v3/*: any*/)
            ],
            "type": "Agent",
            "abstractKey": null
          },
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "nodeId",
                "storageKey": null
              }
            ],
            "type": "Node",
            "abstractKey": "__isNode"
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "141fe91c65a85c79d2438e7442805d21",
    "id": null,
    "metadata": {},
    "name": "UnifiedYourProfilePersonalInformationForm_UpdateAgentProfilePersonalInfoMutation",
    "operationKind": "mutation",
    "text": "mutation UnifiedYourProfilePersonalInformationForm_UpdateAgentProfilePersonalInfoMutation(\n  $input: UpdateAgentProfilePersonalInfoInput!\n) {\n  updateAgentProfilePersonalInfo(input: $input) {\n    __typename\n    ... on Agent {\n      ...UnifiedYourProfilePersonalInformationForm_agent\n      displayName\n    }\n    ... on Node {\n      __isNode: __typename\n      __typename\n      nodeId\n    }\n  }\n}\n\nfragment UnifiedYourProfilePersonalInformationForm_agent on Agent {\n  firstName\n  lastName\n  brokerage\n  phone\n  emailAddress\n  website\n  userEnteredDisplayName\n}\n"
  }
};
})());

let wrap_response_updateAgentProfilePersonalInfo = RescriptRelay_Internal.wrapUnion;

exports.Types = Types;
exports.unwrap_response_updateAgentProfilePersonalInfo = unwrap_response_updateAgentProfilePersonalInfo;
exports.wrap_response_updateAgentProfilePersonalInfo = wrap_response_updateAgentProfilePersonalInfo;
exports.Internal = Internal;
exports.Utils = Utils;
exports.node = node;
/* node Not a pure module */
